import { render, staticRenderFns } from "./format13.vue?vue&type=template&id=3206c87e&"
import script from "./format13.vue?vue&type=script&lang=ts&"
export * from "./format13.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports